import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLowStock } from "../../Redux/actions/pharmacistActions/pharmacistMedicineActions";

const LowStockList = () => {
  const dispatch = useDispatch();
  const { meds, loading, error } = useSelector(
    (state) => state.pharmacy.lowStock || { meds: [], loading: false, error: null }
  );

  useEffect(() => {
    dispatch(fetchLowStock());
  }, [dispatch]);

  return (
    <div className="card p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Low stock</h6>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => dispatch(fetchLowStock())}
        >
          Refresh
        </button>
      </div>

      {loading && <div className="small text-muted">Loading...</div>}
      {error && <div className="text-danger small">{error}</div>}

      {!loading && meds && meds.length === 0 && (
        <div className="text-muted small">No medicines below low-stock limit.</div>
      )}

      <div className="mt-2" style={{ maxHeight: "260px", overflowY: "auto" }}>
  <ul className="list-unstyled mb-0">
    {meds &&
      meds.map((m) => (
        <li
          key={m._id}
          className="d-flex justify-content-between align-items-center border-bottom py-2"
        >
          <div>
            <strong>{m.name}</strong>
            <div className="small text-muted">
              Stock: {m.stock} / Limit: {m.lowStockLimit}
            </div>
          </div>
          <span className="badge bg-danger">Low</span>
        </li>
      ))}
  </ul>
</div>
    </div>
  );
};

export default LowStockList;
